import {SaisineStatus} from './saisine.model';

export class Saisineline {
    constructor(
        public id?: number,
        public reference?: string,
        public licenceTitle?: string,
        public licenceSchoolLabel?: string,
        public firstSubmitDate?: any,
        public lastModificationDate?: any,
        public status?: SaisineStatus,
        public numberAdmissionRequest?: number,
        public numberStudentProposals?: number,
        public numberStudentRefused?: number,
        public numberStudentConfirmed?: number,
        public numberStudentProposalsDisplayed?: string,
        public numberStudentRefusedDisplayed?: string,
        public numberStudentConfirmedDisplayed?: string,
        public licenceAcademyLabel?: string,
        public licenceAcademicRegionLabel?: string,
        public hasDisability?: boolean
    ) {}
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/saisine/saisineline.model.ts